import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const BulletUpperAlphaIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BulletUpperAlpha",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.9 2.69h1.23l4.71 11.09H11.3l-1.12-2.73H4.63l-1.16 2.73H1.99zm.52 1.7L5.14 9.92h4.53L7.41 4.39ZM3.81 18.95h3.2c.19-.02.42-.03.64-.03s.45.01.67.04h-.03c.42.09.8.24 1.14.44h-.02c.32.2.58.47.79.78.18.34.29.72.29 1.14v.2c0 .54-.18 1.04-.49 1.43-.34.4-.8.7-1.32.84h-.02c.35.03.67.12.95.26H9.6c.3.14.55.33.76.55.42.47.67 1.08.67 1.76v.15c0 .49-.13.95-.37 1.34-.24.36-.56.67-.94.88h-.01a3.9 3.9 0 0 1-1.29.47h-.03c-.43.08-.92.13-1.42.13H3.8V18.96Zm1.25 4.44h1.81c.13 0 .28.01.43.01s.3 0 .45-.02h-.02c.29-.04.55-.13.79-.26h-.01c.22-.12.41-.29.54-.49.12-.23.2-.5.2-.78 0-.08 0-.15-.02-.23s0-.03 0-.04c0-.27-.07-.53-.2-.75-.13-.2-.31-.36-.52-.48s-.45-.2-.71-.24h-.01c-.12-.01-.26-.02-.41-.02s-.28 0-.42.02h.02-1.81l-.11 3.27Zm0 4.9h2.11c.32 0 .63-.04.94-.1h-.03c.31-.06.58-.16.83-.31H8.9c.25-.13.45-.33.59-.56s.22-.5.22-.79v-.13c0-.32-.08-.61-.22-.87-.15-.23-.33-.43-.55-.58-.23-.15-.49-.25-.78-.31h-.01c-.14-.02-.3-.02-.47-.02s-.33 0-.49.02h.02-2.13v3.65Zm24.04-9.34H14.65c-.5 0-.9.4-.9.9s.4.9.9.9H29.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9m-7.23 5.42h-7.23c-.5 0-.9.4-.9.9s.4.9.9.9h7.23c.5 0 .9-.4.9-.9s-.4-.9-.9-.9M14.65 7.2H29.1c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H14.65c-.5 0-.9.4-.9.9s.4.9.9.9m0 5.42h7.23c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-7.23c-.5 0-.9.4-.9.9s.4.9.9.9"
    })
  }));
};